module.exports = __webpack_public_path__ + "static/youtube-d91288812389450dabd7ca3bd46cf86a.png";